/** Mulberry32 — small seeded PRNG */

export type Rng = {
  next(): number; // [0, 1)
  int(maxExclusive: number): number;
  uniform(min: number, max: number): number;
};

export function mulberry32(seed: number): Rng {
  let a = seed >>> 0;
  const next = (): number => {
    a = (a + 0x6d2b79f5) >>> 0;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
  return {
    next,
    int(maxExclusive: number) {
      return Math.floor(next() * maxExclusive);
    },
    uniform(min: number, max: number) {
      return min + (max - min) * next();
    },
  };
}

export function makeRng(seed: number | null | undefined): Rng {
  if (seed == null) {
    return mulberry32((Math.random() * 0xffffffff) >>> 0);
  }
  return mulberry32(seed >>> 0);
}
